
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2671',
  depVersions: {
  "customer-portal-app": "static-1.2671",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9775",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25719",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5706",
  "hs-test-utils": "static-1.8134",
  "hub-http": "static-1.6336",
  "hub-http-shared-msw-handlers": "static-1.10250",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18570",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11589",
  "I18n": "static-7.1638",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6572",
  "payment-link-components": "static-1.23829",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7175",
  "quartz-core": "static-1.6394",
  "quartz-i18n": "static-1.850",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10321",
  "react-dlb": "static-1.81",
  "react-utils": "static-2.5425",
  "rich-text-lib": "static-1.20033",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18150",
  "ui-components-test-utils": "static-1.5726",
  "UIComponents": "static-3.8535",
  "foundations-assets": "static-1.4987",
  "foundations-components": "static-1.8161",
  "foundations-theming": "static-1.4545",
  "foundations-theming-specialty": "static-1.2261",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1168",
  "quartz-config": "static-1.953",
  "quartz-routing": "static-1.605",
  "quick-fetch": "static-1.4001",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16798",
  "rpc-client-utils": "static-1.4771",
  "sanitize-text": "static-1.8259",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4873",
  "ui-addon-react-router-dom": "static-1.9651",
  "usage-tracker": "static-1.7463",
  "usage-tracker-anonymous": "static-1.5880",
  "usage-tracker-core": "static-1.7313",
  "video-components-external": "static-1.11652",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3481",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3452",
  "quartz-webpack": "static-1.3399",
  "bend-plugin-quartz-routing": "static-1.253",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7792",
  "frontend-preferences-client": "static-1.8041",
  "laboratory-lib": "static-3.7267",
  "onboarding-scopes": "static-1.6574",
  "seat-types-lib": "static-1.270",
  "ui-addon-opt": "static-4.8475",
  "HeadJS": "static-2.769",
  "hs-test-utils-bend-plugin": "static-1.3245",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.165",
  "ts-schema": "static-1.4165",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7939",
  "content-media-capture": "static-1.4863",
  "cssUtils": "static-1.824",
  "customer-data-ui-utilities": "static-1.9939",
  "file-manager-components": "static-1.23946",
  "HubStyle": "static-2.11896",
  "knowledge-content-types": "static-1.8559",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.489",
  "ui-addon-emoji-picker": "static-1.10000",
  "ui-addon-i18n": "static-1.11263",
  "ui-business-units-lib": "static-1.9181",
  "ui-shepherd-react": "static-3.10360",
  "video-data-lib": "static-1.35310",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4439",
  "commerce-tours-lib": "static-1.6313",
  "customer-data-properties": "static-1.51970",
  "getting-started-shared-tasks": "static-1.18734",
  "growth-onboarding-reliability": "static-1.5195",
  "onboarding-tours": "static-1.16820",
  "reference-resolvers-lite": "static-1.8211",
  "sales-checkout-service-client": "static-1.3707",
  "ui-addon-iframeable": "static-1.9181",
  "user-context": "static-1.5223",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.845",
  "hubspotter-http": "static-1.4734",
  "icons": "static-2.654",
  "mobile-manifest-mixins": "static-1.544",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.850",
  "quartz-head": "static-1.840",
  "quartz-test": "static-1.850",
  "quartz-tracking": "static-1.554",
  "trellis-components": "static-1.2210",
  "ui-fonts": "static-1.851",
  "usage-tracker-container": "static-1.7453",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9537",
  "data-token-picker": "static-1.16613",
  "FileManagerLib": "static-1.39586",
  "property-translator": "static-1.5510",
  "atom": "static-1.5189",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6089",
  "salesImages": "static-1.527",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5644",
  "react-create-root-preference": "static-1.36",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1181",
  "bend-plugin-foundations-components": "static-1.4430",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "trellis-assets": "static-1.2191",
  "bend-plugin-foundations-theming": "static-1.3028",
  "foundations-theming-base": "static-1.3530",
  "stylex": "static-1.35",
  "interframe": "static-3.4874",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5877",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.181",
  "chirp-fetch": "static-1.2001",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4590",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4765",
  "content-media-composition-data-lib": "static-1.12667",
  "content-media-compositions": "static-2.16674",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4264",
  "magpie-lib": "static-1.5626",
  "magpie-types": "static-1.5086",
  "media-bridge-lib": "static-1.19128",
  "bender-build-tools": "static-1.3281",
  "inbound-db-properties-service-client": "static-1.3928",
  "superstore": "static-1.4873",
  "feedback-loader": "static-1.29516",
  "ai-components-ui-library": "static-1.9249",
  "ui-addon-video-player": "static-1.8817",
  "ui-coaching-tips": "static-1.28882",
  "ContentUtils": "static-1.68698",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4539",
  "sassPrefix": "static-1.158",
  "react-dnd-compat": "static-1.4728",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2611",
  "navigation-messaging": "static-1.7622",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8288",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9986",
  "crm-message-bus": "static-1.43285",
  "growth-data-modal": "static-1.5615",
  "hubspot-apollo-client": "static-1.4991",
  "onboarding-tours-client": "static-1.5034",
  "calling-global-api": "static-1.64913",
  "calling-internal-common": "static-1.31424",
  "calling-lifecycle-internal": "static-1.66295",
  "calling-lifecycle-messages": "static-1.58589",
  "conditional-properties-service-client": "static-1.3880",
  "crm-links": "static-1.6422",
  "crm-pipelines-api-client-types": "static-1.4220",
  "customer-data-objects-ui-components": "static-1.13143",
  "customer-data-properties-shared-msw-handlers": "static-1.9577",
  "customer-data-property-utils": "static-1.8209",
  "external-options-client-types": "static-1.4210",
  "framework-data-schema-resolvers": "static-1.7006",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.288",
  "inbound-db-meta-service-client": "static-1.3670",
  "inbounddb-objects-service-types": "static-1.4300",
  "meetings-icalendar-utils-lib": "static-1.747",
  "multi-currency-client-types": "static-1.3773",
  "object-builder-ui-client": "static-1.49144",
  "pipeline-validation-client-types": "static-1.4049",
  "property-value-citations": "static-1.2584",
  "pulse": "static-1.716",
  "smart-property-lib": "static-1.7809",
  "tiered-pricing": "static-1.1517",
  "ui-addon-form-validation": "static-1.11104",
  "zustand": "static-1.74",
  "growth-onboarding-confetti": "static-1.3179",
  "growth-onboarding-next-action-utils": "static-1.2250",
  "navigation-components": "static-1.18295",
  "onboarding-tours-utils": "static-1.886",
  "ui-shepherd-tracker": "static-1.7741",
  "ui-universal-auth": "static-1.9115",
  "batch-promise": "static-1.1657",
  "getting-started-shared-tasks-store": "static-1.17852",
  "hubspotter-http-shared-msw-handlers": "static-1.10248",
  "usage-tracker-session-replay": "static-1.5149",
  "base-ui": "static-1.14",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1055",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.6095",
  "FileManagerCore": "static-1.39445",
  "FileManagerImages": "static-1.37097",
  "video-components": "static-1.13654",
  "foundations-components-legacy": "static-1.1186",
  "purchase-motions-api": "static-1.6092",
  "signup-constants": "static-1.19126",
  "signup-ui-url-generator": "static-2.8171",
  "usage-tracker-public": "static-1.7274",
  "reactive-lib": "static-1.839",
  "simple-logging-lib": "static-1.3162",
  "chatspot-core": "static-1.21845",
  "copilot-toolkit": "static-1.11435",
  "growth-onboarding-feedback-components": "static-1.6692",
  "cms-field-types": "static-1.4929",
  "content-icons-ui": "static-1.2258",
  "integrations-lib": "static-1.16523",
  "underscore": "static-1.8",
  "commerce-permissions": "static-1.890",
  "customer-data-tracking": "static-1.7001",
  "products-iframe-lib": "static-1.8250",
  "products-ui-components-shared-msw-handlers": "static-1.10632",
  "restore-request-side-panel-lib": "static-1.1169",
  "onboarding-data-sync-lib": "static-1.2162",
  "hubspot-apollo-cache": "static-1.450",
  "calling-error-reporting": "static-1.31431",
  "shared-worker-versioning": "static-1.11149",
  "calling-usage-tracker": "static-1.6657",
  "voice-sms-access-library": "static-1.1440",
  "conversations-skeleton-state": "static-1.7361",
  "location-customization-utils-lib": "static-1.9601",
  "fdsr-migration-layer": "static-1.125",
  "framework-builder-read-service-client": "static-1.4087",
  "framework-data-schema-quick-fetch": "static-1.6911",
  "persist-promise": "static-1.3814",
  "event-emitter": "static-1.1063",
  "bend-plugin-pulse": "static-1.219",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.388",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10333",
  "fsm": "static-1.3842",
  "policy-lib": "static-1.6896",
  "react-tinymce": "static-1.55550",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10396",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54676",
  "tinymce-plugins": "static-1.57790",
  "tinymce-themes": "static-1.56646",
  "growth-onboarding-next-action-components": "static-1.2278",
  "user-context-client": "static-1.4694",
  "nest": "static-1.345",
  "unified-auth-core-lib": "static-1.911",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4649",
  "video-embed": "static-1.36144",
  "social-insights-client-types": "static-1.22337",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1120",
  "flux-actions": "static-1.346",
  "integrations-error-boundary-lib": "static-1.13938",
  "integrations-tracking-lib": "static-1.5720",
  "native-integrations-shared-strings": "static-1.7896",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10476",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.629",
  "sales-views-client-types": "static-1.4370",
  "InboxConnectUtils": "static-4.15115",
  "meetings-connect-utils-lib": "static-1.7719",
  "calling-orchestration-schema": "static-1.36217",
  "crm-record-cards-service-types": "static-1.3671",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4625",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3157",
  "tinymce-data": "static-1.40761",
  "ui-addon-sales-email": "static-1.5323",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12671",
  "layout-dnd-utils": "static-1.11646",
  "react-codemirror": "static-1.10741",
  "ui-brand-identity-lib": "static-1.15696",
  "NamespacedHubStyle": "static-2.9137",
  "outpost": "static-1.4283",
  "breeze-engine-core": "static-1.398",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3131",
  "adobe-sign-auth-lib": "static-1.16",
  "ads-unified-auth-lib": "static-1.374",
  "google-sheets-integration-lib": "static-1.579",
  "microsoft-drive-integration-lib": "static-1.711",
  "surveymonkey-integration-lib": "static-1.36",
  "slack-ui-library": "static-1.10510",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68773",
  "layout-data-lib": "static-1.9971",
  "browser-eslint": "static-2.57",
  "advanced-menus-core": "static-1.15321",
  "advanced-menus-lib": "static-1.12234",
  "ExportDialog": "static-6.10494",
  "ui-memberships-settings-lib": "static-1.34353",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15320",
  "simple-menus-lib": "static-1.16837"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2671",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9775",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25719",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5706",
  "hs-test-utils": "/hs-test-utils/static-1.8134",
  "hub-http": "/hub-http/static-1.6336",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10250",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18570",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11589",
  "I18n": "/I18n/static-7.1638",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6572",
  "payment-link-components": "/payment-link-components/static-1.23829",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7175",
  "quartz-core": "/quartz-core/static-1.6394",
  "quartz-i18n": "/quartz-i18n/static-1.850",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10321",
  "react-dlb": "/react-dlb/static-1.81",
  "react-utils": "/react-utils/static-2.5425",
  "rich-text-lib": "/rich-text-lib/static-1.20033",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18150",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5726",
  "UIComponents": "/UIComponents/static-3.8535",
  "foundations-assets": "/foundations-assets/static-1.4987",
  "foundations-components": "/foundations-components/static-1.8161",
  "foundations-theming": "/foundations-theming/static-1.4545",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2261",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1168",
  "quartz-config": "/quartz-config/static-1.953",
  "quartz-routing": "/quartz-routing/static-1.605",
  "quick-fetch": "/quick-fetch/static-1.4001",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16798",
  "rpc-client-utils": "/rpc-client-utils/static-1.4771",
  "sanitize-text": "/sanitize-text/static-1.8259",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4873",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9651",
  "usage-tracker": "/usage-tracker/static-1.7463",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5880",
  "usage-tracker-core": "/usage-tracker-core/static-1.7313",
  "video-components-external": "/video-components-external/static-1.11652",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3481",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3452",
  "quartz-webpack": "/quartz-webpack/static-1.3399",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.253",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7792",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8041",
  "laboratory-lib": "/laboratory-lib/static-3.7267",
  "onboarding-scopes": "/onboarding-scopes/static-1.6574",
  "seat-types-lib": "/seat-types-lib/static-1.270",
  "ui-addon-opt": "/ui-addon-opt/static-4.8475",
  "HeadJS": "/HeadJS/static-2.769",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3245",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.165",
  "ts-schema": "/ts-schema/static-1.4165",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7939",
  "content-media-capture": "/content-media-capture/static-1.4863",
  "cssUtils": "/cssUtils/static-1.824",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9939",
  "file-manager-components": "/file-manager-components/static-1.23946",
  "HubStyle": "/HubStyle/static-2.11896",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10000",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11263",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9181",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10360",
  "video-data-lib": "/video-data-lib/static-1.35310",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4439",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6313",
  "customer-data-properties": "/customer-data-properties/static-1.51970",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18734",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5195",
  "onboarding-tours": "/onboarding-tours/static-1.16820",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8211",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3707",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9181",
  "user-context": "/user-context/static-1.5223",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.845",
  "hubspotter-http": "/hubspotter-http/static-1.4734",
  "icons": "/icons/static-2.654",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.544",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.850",
  "quartz-head": "/quartz-head/static-1.840",
  "quartz-test": "/quartz-test/static-1.850",
  "quartz-tracking": "/quartz-tracking/static-1.554",
  "trellis-components": "/trellis-components/static-1.2210",
  "ui-fonts": "/ui-fonts/static-1.851",
  "usage-tracker-container": "/usage-tracker-container/static-1.7453",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9537",
  "data-token-picker": "/data-token-picker/static-1.16613",
  "FileManagerLib": "/FileManagerLib/static-1.39586",
  "property-translator": "/property-translator/static-1.5510",
  "atom": "/atom/static-1.5189",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6089",
  "salesImages": "/salesImages/static-1.527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5644",
  "react-create-root-preference": "/react-create-root-preference/static-1.36",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1181",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4430",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.2191",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3028",
  "foundations-theming-base": "/foundations-theming-base/static-1.3530",
  "stylex": "/stylex/static-1.35",
  "interframe": "/interframe/static-3.4874",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5877",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.181",
  "chirp-fetch": "/chirp-fetch/static-1.2001",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4590",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4765",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12667",
  "content-media-compositions": "/content-media-compositions/static-2.16674",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4264",
  "magpie-lib": "/magpie-lib/static-1.5626",
  "magpie-types": "/magpie-types/static-1.5086",
  "media-bridge-lib": "/media-bridge-lib/static-1.19128",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3928",
  "superstore": "/superstore/static-1.4873",
  "feedback-loader": "/feedback-loader/static-1.29516",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9249",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8817",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28882",
  "ContentUtils": "/ContentUtils/static-1.68698",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4539",
  "sassPrefix": "/sassPrefix/static-1.158",
  "react-dnd-compat": "/react-dnd-compat/static-1.4728",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2611",
  "navigation-messaging": "/navigation-messaging/static-1.7622",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8288",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9986",
  "crm-message-bus": "/crm-message-bus/static-1.43285",
  "growth-data-modal": "/growth-data-modal/static-1.5615",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4991",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5034",
  "calling-global-api": "/calling-global-api/static-1.64913",
  "calling-internal-common": "/calling-internal-common/static-1.31424",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66295",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58589",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3880",
  "crm-links": "/crm-links/static-1.6422",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4220",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13143",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9577",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8209",
  "external-options-client-types": "/external-options-client-types/static-1.4210",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7006",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.288",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3670",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4300",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.747",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3773",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49144",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4049",
  "property-value-citations": "/property-value-citations/static-1.2584",
  "pulse": "/pulse/static-1.716",
  "smart-property-lib": "/smart-property-lib/static-1.7809",
  "tiered-pricing": "/tiered-pricing/static-1.1517",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11104",
  "zustand": "/zustand/static-1.74",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3179",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2250",
  "navigation-components": "/navigation-components/static-1.18295",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.886",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7741",
  "ui-universal-auth": "/ui-universal-auth/static-1.9115",
  "batch-promise": "/batch-promise/static-1.1657",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17852",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10248",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5149",
  "base-ui": "/base-ui/static-1.14",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1055",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.6095",
  "FileManagerCore": "/FileManagerCore/static-1.39445",
  "FileManagerImages": "/FileManagerImages/static-1.37097",
  "video-components": "/video-components/static-1.13654",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1186",
  "purchase-motions-api": "/purchase-motions-api/static-1.6092",
  "signup-constants": "/signup-constants/static-1.19126",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8171",
  "usage-tracker-public": "/usage-tracker-public/static-1.7274",
  "reactive-lib": "/reactive-lib/static-1.839",
  "simple-logging-lib": "/simple-logging-lib/static-1.3162",
  "chatspot-core": "/chatspot-core/static-1.21845",
  "copilot-toolkit": "/copilot-toolkit/static-1.11435",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6692",
  "cms-field-types": "/cms-field-types/static-1.4929",
  "content-icons-ui": "/content-icons-ui/static-1.2258",
  "integrations-lib": "/integrations-lib/static-1.16523",
  "underscore": "/underscore/static-1.8",
  "commerce-permissions": "/commerce-permissions/static-1.890",
  "customer-data-tracking": "/customer-data-tracking/static-1.7001",
  "products-iframe-lib": "/products-iframe-lib/static-1.8250",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10632",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1169",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2162",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.450",
  "calling-error-reporting": "/calling-error-reporting/static-1.31431",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11149",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6657",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1440",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7361",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9601",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.125",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4087",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6911",
  "persist-promise": "/persist-promise/static-1.3814",
  "event-emitter": "/event-emitter/static-1.1063",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.219",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.388",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10333",
  "fsm": "/fsm/static-1.3842",
  "policy-lib": "/policy-lib/static-1.6896",
  "react-tinymce": "/react-tinymce/static-1.55550",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10396",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54676",
  "tinymce-plugins": "/tinymce-plugins/static-1.57790",
  "tinymce-themes": "/tinymce-themes/static-1.56646",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2278",
  "user-context-client": "/user-context-client/static-1.4694",
  "nest": "/nest/static-1.345",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.911",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4649",
  "video-embed": "/video-embed/static-1.36144",
  "social-insights-client-types": "/social-insights-client-types/static-1.22337",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1120",
  "flux-actions": "/flux-actions/static-1.346",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13938",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5720",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7896",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10476",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.629",
  "sales-views-client-types": "/sales-views-client-types/static-1.4370",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15115",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7719",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36217",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4625",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3157",
  "tinymce-data": "/tinymce-data/static-1.40761",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5323",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12671",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11646",
  "react-codemirror": "/react-codemirror/static-1.10741",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15696",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9137",
  "outpost": "/outpost/static-1.4283",
  "breeze-engine-core": "/breeze-engine-core/static-1.398",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3131",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.16",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.374",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.579",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.711",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.36",
  "slack-ui-library": "/slack-ui-library/static-1.10510",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68773",
  "layout-data-lib": "/layout-data-lib/static-1.9971",
  "browser-eslint": "/browser-eslint/static-2.57",
  "advanced-menus-core": "/advanced-menus-core/static-1.15321",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12234",
  "ExportDialog": "/ExportDialog/static-6.10494",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34353",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15320",
  "simple-menus-lib": "/simple-menus-lib/static-1.16837"
}
};
